import { TranslateModule } from '@ngx-translate/core';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { CLIENT_APP_ID, ClientAppId } from '@sc/data-access-models';

@Component({
  selector: 'sc-already-abandonned-dialog',
  styleUrls: ['./already-abandonned-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule],
  template: `
    <div class="container">
      <div class="common-container">
        <div class="description">
          <h3
            class="sc-design-title-h3"
            [innerHTML]="'AbandonCaseDialog.title' | translate"
          ></h3>
          <p
            class="sc-design-text-3"
            [innerHTML]="
              'AbandonCaseDialog.text' | translate: { clientAppId: clientAppId }
            "
          ></p>
        </div>
      </div>
    </div>
  `,
})
export class AlreadyAbandonnedDialogComponent {
  constructor(@Inject(CLIENT_APP_ID) public clientAppId: ClientAppId) {}
}
